import parent from '../Pages/path';

export default `${parent}/invites/:inviteId`;
